import React from "react";
import { useState, useEffect } from "react";
import {
  Button,
  Card,
  Divider,
  FormControl,
  Grid,
  InputAdornment,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import Swal from "sweetalert2";
import { useNavigate, useParams } from "react-router-dom";
import NumberFormatting from "../../helper/NumberFormatting";
import { postDataWithParams } from "../../../service/Service";
import {
  getInvoiceById,
  invoiceActions,
  updateInvoice,
} from "../../../redux/reducer/invoice/invoiceReducer";
import moment from "moment";

const useStyles = makeStyles(() => ({
  headerClass: {
    display: "flex",
    alignItems: "flex-start",
    width: "100%",
    flexDirection: "column",
    padding: "5px",
    margin: "10px 0px",
    background: "#F2F2F2",
  },
  dividerStyle: {
    border: "1px solid #386E5B",
    width: "100%",
    margin: "5px 0px",
  },
  footerButton: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "flex-end",
    marginBottom: "10px",
    width: "99%",
  },
  tableHeader: {
    background: "#ddd",
    textAlign: "center",
    borderBottom: "1px solid #D1CDCD",
    padding: "1em",
  },
  tableCell: {
    background: "#ddd",
    borderBottom: "1px solid #D1CDCD",
    padding: "5px 0px",
  },
  actionButtonEdit: {
    backgroundColor: "#dde0f0",
    color: "#A0A3B3",
    fontSize: "25px",
    textAlign: "center",
    borderRadius: "5px",
    margin: "auto",
    cursor: "pointer",
    "&:hover": {
      background: "#7dbda9",
    },
  },
}));

export default function AdminInvoiceEdit() {
  // Navigate
  const navigate = useNavigate();
  const { id } = useParams();

  // Styling
  const styles = useStyles();

  // Redux Data
  const dispatch = useDispatch();
  const token = useSelector((state) => state.auth.token);
  const user = useSelector((state) => state.auth.dataToken);
  const data = useSelector((state) => state.invoice.data);

  // Local State
  const [formData, setFormData] = useState({
    invoiceCode: "",
    deliveryOrderId: "",
    customerId: "",
    totalPayment: "",
    taxPayment: "",
    discounts: "",
    paymentDate: "",
    employeeId: "",
    description: "",
  });
  const [customer, setCustomer] = useState([]);
  const [deliveryOrder, setDeliveryOrder] = useState([]);
  const [employee, setEmployee] = useState([]);
  const [orderDetails, setOrderDetails] = useState([]);
  const [fetch, setFetch] = useState(true);

  useEffect(() => {
    if (fetch) {
      let body = {};
      let params = {
        paginate: false,
      };
      postDataWithParams("/master/customer/search", token, body, params)
        .then((res) => {
          if (res.data.status === 200) {
            setCustomer([...res.data.data.docs]);
          } else {
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          toast.error(err.response.message);
        });
      postDataWithParams("/admin/delivery-order/search", token, body, params)
        .then((res) => {
          console.log(res);
          if (res.data.status === 200) {
            setDeliveryOrder([...res.data.data.docs]);
          } else {
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          toast.error(err.response.message);
        });
      postDataWithParams("/master/employee/search", token, body, params)
        .then((res) => {
          if (res.data.status === 200) {
            setEmployee([...res.data.data.docs]);
          } else {
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          toast.error(err.response.message);
        });
      let x = data.docs.findIndex((item) => item._id === id);
      if (x > -1) {
        setFormData({
          invoiceCode: data.docs[x].invoiceCode ? data.docs[x].invoiceCode : "",
          employeeId: data.docs[x].employeeId
            ? data.docs[x].employeeId._id
            : "",
          deliveryOrderId: data.docs[x].deliveryOrderId
            ? data.docs[x].deliveryOrderId._id
            : "",
          customerId: data.docs[x].customerId
            ? data.docs[x].customerId._id
            : "",
          description: data.docs[x].description
            ? data.docs[x].description
            : "-",
          totalPayment: data.docs[x].paymentDetails
            ? data.docs[x].paymentDetails.totalPayment
            : "",
          discounts: data.docs[x].paymentDetails
            ? data.docs[x].paymentDetails.discounts
            : "",
          taxPayment: data.docs[x].paymentDetails
            ? data.docs[x].paymentDetails.taxPayment
            : "",
          paymentDate: data.docs[x].paymentDetails
            ? moment(data.docs[x].paymentDetails.paymentDate).format(
                "YYYY-MM-DD"
              )
            : "",
        });
        setOrderDetails([...data.docs[x].deliveryOrderId.orderDetails]);
      }
      setFetch(false);
    }
  }, [fetch]);

  // Basic Handle Change
  const handleChange = (e) => {
    if (e.target.name === "deliveryOrderId") {
      let x = deliveryOrder.findIndex((item) => item._id === e.target.value);
      setFormData({
        ...formData,
        ["deliveryOrderId"]: e.target.value,
        ["customerId"]: deliveryOrder[x].customerId._id,
        ["totalPayment"]: deliveryOrder[x].totalPrices,
      });
      setOrderDetails([...deliveryOrder[x].orderDetails]);
    } else {
      setFormData({
        ...formData,
        [e.target.name]: e.target.value,
      });
    }
  };

  const handleSubmitAll = (e) => {
    e.preventDefault();
    Swal.fire({
      title: `Mohon dicek kembali data yang akan di input`,
      icon: "warning",
      buttons: true,
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Tambah",
      cancelButtonText: "Batal",
    }).then((confirm) => {
      if (confirm.isConfirmed) {
        let data = {
          value: {
            invoiceCode: formData.invoiceCode,
            deliveryOrderId: formData.deliveryOrderId,
            customerId: formData.customerId,
            paymentDetails: {
              totalPayment: formData.totalPayment,
              taxPayment: formData.taxPayment,
              discounts: formData.discounts,
              paymentDate: moment(formData.paymentDate).format(),
            },
            employeeId: formData.employeeId,
            description: formData.description,
            status: 1,
            createdBy: user.username,
            updatedBy: user.username,
          },
          id: id,
          token: token,
        };
        dispatch(updateInvoice(data)).then((res) => {
          if (res.payload.status === 200) {
            let dataGetById = {
              id: res.payload.data._id,
              token: token,
            };
            dispatch(getInvoiceById(dataGetById)).then((result) => {
              dispatch(invoiceActions.editInvoice(result.payload.data));
              toast.success(res.payload.message);
              navigate("/admin/invoice");
            });
          } else {
            console.log(res);
          }
        });
      } else {
        return;
      }
    });
  };

  // Column
  const orderDetailsColumn = [
    "SAYURAN",
    "ORDER",
    "DELIVER",
    "TOTAL ORDER",
    "HARGA",
  ];
  
  return (
    <Grid container>
      <ToastContainer />
      <Card className={styles.headerClass}>
        <Typography fontSize={20} fontWeight={600} color={"#0A543B"}>
          EDIT INVOICE
        </Typography>
      </Card>
      <form
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          marginTop: "10px",
        }}
        onSubmit={handleSubmitAll}
      >
        <Card className={styles.headerClass}>
          <Grid
            container
            direction={"row"}
            justifyContent={"space-between"}
            alignItems="center"
            minWidth={"100%"}
          >
            <Grid items>
              <Typography fontSize={16} color={"#2D6B56"} variant="h6">
                INFORMASI INVOICE
              </Typography>
            </Grid>
          </Grid>
          <Divider className={styles.dividerStyle} />

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              margin: "10px 0px",
              flexDirection: "row",
              background: "none",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              KODE INVOICE
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              inputProps={{ maxLength: 20, style: { background: "white" } }}
              InputProps={{ readOnly: true }}
              required
              helperText={
                formData.invoiceCode.length > 0
                  ? /^[A-Za-z]{3}-\d{5}/.test(formData.invoiceCode)
                    ? ""
                    : "*Format Kode Invoice Salah"
                  : ""
              }
              size="small"
              error={
                formData.invoiceCode.length > 0
                  ? /^[A-Za-z]{3}-\d{5}/.test(formData.invoiceCode)
                    ? false
                    : true
                  : false
              }
              name="invoiceCode"
              onChange={handleChange}
              value={formData.invoiceCode}
              fullWidth
              variant="outlined"
              style={{
                maxWidth: "400px",
                marginRight: "10px",
              }}
            />
          </FormControl>

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              margin: "10px 0px",
              flexDirection: "row",
              background: "none",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              SURAT JALAN
            </Typography>
            <TextField
              select
              InputLabelProps={{ shrink: true }}
              required
              size="small"
              error={false}
              name="deliveryOrderId"
              onChange={handleChange}
              value={formData.deliveryOrderId}
              fullWidth
              variant="outlined"
              SelectProps={{
                MenuProps: {
                  style: {
                    height: "300px",
                  },
                },
              }}
              style={{
                maxWidth: "400px",
                background: "white",
                marginRight: "10px",
              }}
            >
              {deliveryOrder.length > 0 ? (
                deliveryOrder.map((data, index) => (
                  <MenuItem value={data._id} key={index}>
                    {data.deliveryOrderCode}
                  </MenuItem>
                ))
              ) : (
                <MenuItem value="">Data kosong</MenuItem>
              )}
            </TextField>
          </FormControl>

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              margin: "10px 0px",
              flexDirection: "row",
              background: "none",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              CUSTOMER
            </Typography>
            <TextField
              select
              InputLabelProps={{ shrink: true }}
              inputProps={{ readOnly: true }}
              required
              size="small"
              error={false}
              name="customerId"
              onChange={handleChange}
              value={formData.customerId}
              fullWidth
              variant="outlined"
              SelectProps={{
                MenuProps: {
                  style: {
                    height: "300px",
                  },
                },
              }}
              style={{
                maxWidth: "400px",
                background: "white",
                marginRight: "10px",
              }}
            >
              {customer.length > 0 ? (
                customer.map((data, index) => (
                  <MenuItem value={data._id} key={index}>
                    {data.customerName}
                  </MenuItem>
                ))
              ) : (
                <MenuItem value="">Data kosong</MenuItem>
              )}
            </TextField>
          </FormControl>

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              margin: "10px 0px",
              flexDirection: "row",
              background: "none",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              KARYAWAN
            </Typography>
            <TextField
              select
              InputLabelProps={{ shrink: true }}
              required
              size="small"
              error={false}
              name="employeeId"
              onChange={handleChange}
              value={formData.employeeId}
              fullWidth
              variant="outlined"
              SelectProps={{
                MenuProps: {
                  style: {
                    height: "300px",
                  },
                },
              }}
              style={{
                maxWidth: "400px",
                background: "white",
                marginRight: "10px",
              }}
            >
              {employee.length > 0 ? (
                employee.map((data, index) => (
                  <MenuItem value={data._id} key={index}>
                    {data.fullName}
                  </MenuItem>
                ))
              ) : (
                <MenuItem value="">Data kosong</MenuItem>
              )}
            </TextField>
          </FormControl>

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              margin: "10px 0px",
              flexDirection: "row",
              background: "none",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              KETERANGAN
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              required
              size="small"
              error={false}
              name="description"
              onChange={handleChange}
              value={formData.description}
              variant="outlined"
              fullWidth
              style={{
                maxWidth: "400px",
                background: "white",
                marginRight: "10px",
              }}
            />
          </FormControl>
        </Card>
        <Card className={styles.headerClass}>
          <Grid
            container
            direction={"row"}
            justifyContent={"space-between"}
            alignItems="center"
            minWidth={"100%"}
          >
            <Grid items>
              <Typography fontSize={16} color={"#2D6B56"} variant="h6">
                DETAIL ORDER
              </Typography>
            </Grid>
          </Grid>
          <Divider className={styles.dividerStyle} />
          <table
            style={{
              width: "98%",
              margin: "10px",
              borderCollapse: "collapse",
              borderRadius: "1em",
              overflow: "hidden",
            }}
          >
            <thead>
              {orderDetailsColumn.map((item, index) => {
                return (
                  <td className={styles.tableHeader} key={index}>
                    {item}
                  </td>
                );
              })}
            </thead>
            <tbody>
              {orderDetails.length > 0 &&
                orderDetails.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td
                        className={styles.tableCell}
                        style={{ width: "250px" }}
                      >
                        <FormControl
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyItems: "flex-start",
                            flexDirection: "row",
                            margin: "auto",
                            width: "90%",
                          }}
                        >
                          <TextField
                            select
                            InputLabelProps={{ shrink: true }}
                            inputProps={{ readOnly: true }}
                            required
                            size="small"
                            error={false}
                            name="vegetablePriceId"
                            value={item.vegetablePriceId._id}
                            fullWidth
                            variant="outlined"
                            SelectProps={{
                              MenuProps: {
                                style: {
                                  height: "300px",
                                },
                              },
                            }}
                            style={{
                              maxWidth: "400px",
                              background: "white",
                              marginRight: "10px",
                            }}
                          >
                            <MenuItem
                              value={item.vegetablePriceId._id}
                              key={index}
                            >
                              {item.vegetablePriceId.vegetableName}
                            </MenuItem>
                          </TextField>
                        </FormControl>
                      </td>

                      <td className={styles.tableCell}>
                        <FormControl
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyItems: "flex-start",
                            flexDirection: "row",
                            margin: "auto",
                            width: "90%",
                          }}
                        >
                          <TextField
                            InputLabelProps={{ shrink: true }}
                            inputProps={{ readOnly: true }}
                            required
                            size="small"
                            InputProps={{
                              inputComponent: NumberFormatting,
                              endAdornment: (
                                <InputAdornment position="end"></InputAdornment>
                              ),
                            }}
                            error={false}
                            name="order"
                            id={index}
                            value={item.order}
                            variant="outlined"
                            fullWidth
                            style={{
                              background: "white",
                              marginRight: "10px",
                            }}
                          />
                        </FormControl>
                      </td>

                      <td className={styles.tableCell}>
                        <FormControl
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyItems: "flex-start",
                            flexDirection: "row",
                            margin: "auto",
                            width: "90%",
                          }}
                        >
                          <TextField
                            InputLabelProps={{ shrink: true }}
                            required
                            size="small"
                            InputProps={{
                              inputComponent: NumberFormatting,
                              endAdornment: (
                                <InputAdornment position="end"></InputAdornment>
                              ),
                            }}
                            error={false}
                            name="deliver"
                            id={index}
                            value={item.deliver}
                            variant="outlined"
                            fullWidth
                            style={{
                              background: "white",
                              marginRight: "10px",
                            }}
                          />
                        </FormControl>
                      </td>

                      <td className={styles.tableCell}>
                        <FormControl
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyItems: "flex-start",
                            flexDirection: "row",
                            margin: "auto",
                            width: "90%",
                          }}
                        >
                          <TextField
                            InputLabelProps={{ shrink: true }}
                            inputProps={{ readOnly: true }}
                            required
                            size="small"
                            InputProps={{
                              inputComponent: NumberFormatting,
                              endAdornment: (
                                <InputAdornment position="end"></InputAdornment>
                              ),
                            }}
                            error={false}
                            name="totalOrder"
                            id={index}
                            value={item.totalOrder}
                            variant="outlined"
                            fullWidth
                            style={{
                              background: "white",
                              marginRight: "10px",
                            }}
                          />
                        </FormControl>
                      </td>

                      <td className={styles.tableCell}>
                        <FormControl
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyItems: "flex-start",
                            flexDirection: "row",
                            margin: "auto",
                            width: "90%",
                          }}
                        >
                          <TextField
                            InputLabelProps={{ shrink: true }}
                            InputProps={{ readOnly: true }}
                            required
                            size="small"
                            error={false}
                            name="price"
                            id={index}
                            value={item.price.toLocaleString("id", {
                              style: "currency",
                              currency: "IDR",
                            })}
                            variant="outlined"
                            fullWidth
                            style={{
                              background: "white",
                              marginRight: "10px",
                            }}
                          />
                        </FormControl>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </Card>

        <Card className={styles.headerClass}>
          <Grid
            container
            direction={"row"}
            justifyContent={"space-between"}
            alignItems="center"
            minWidth={"100%"}
          >
            <Grid items>
              <Typography fontSize={16} color={"#2D6B56"} variant="h6">
                DETAIL PEMBAYARAN
              </Typography>
            </Grid>
          </Grid>
          <Divider className={styles.dividerStyle} />

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              margin: "10px 0px",
              flexDirection: "row",
              background: "none",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              TOTAL PAYMENT
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              inputProps={{ readOnly: true }}
              required
              size="small"
              InputProps={{
                inputComponent: NumberFormatting,
                endAdornment: <InputAdornment position="end"></InputAdornment>,
              }}
              error={false}
              name="totalPayment"
              onChange={handleChange}
              value={formData.totalPayment}
              variant="outlined"
              fullWidth
              style={{
                maxWidth: "400px",
                marginRight: "10px",
                background: "white",
              }}
            />
          </FormControl>

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              margin: "10px 0px",
              flexDirection: "row",
              background: "none",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              PAJAK
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              required
              size="small"
              InputProps={{
                inputComponent: NumberFormatting,
                endAdornment: <InputAdornment position="end"></InputAdornment>,
              }}
              error={false}
              name="taxPayment"
              onChange={handleChange}
              value={formData.taxPayment}
              variant="outlined"
              fullWidth
              style={{
                maxWidth: "400px",
                marginRight: "10px",
                background: "white",
              }}
            />
          </FormControl>

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              margin: "10px 0px",
              flexDirection: "row",
              background: "none",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              DISKON
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              required
              size="small"
              InputProps={{
                inputComponent: NumberFormatting,
                endAdornment: <InputAdornment position="end"></InputAdornment>,
              }}
              error={false}
              name="discounts"
              onChange={handleChange}
              value={formData.discounts}
              variant="outlined"
              fullWidth
              style={{
                maxWidth: "400px",
                marginRight: "10px",
                background: "white",
              }}
            />
          </FormControl>

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              margin: "10px 0px",
              flexDirection: "row",
              background: "none",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              TANGGAL PEMBAYARAN
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              required
              size="small"
              type="date"
              error={false}
              name="paymentDate"
              onChange={handleChange}
              value={formData.paymentDate}
              variant="outlined"
              fullWidth
              style={{
                maxWidth: "400px",
                marginRight: "10px",
                background: "white",
              }}
            />
          </FormControl>

          <div className={styles.footerButton}>
            <Button variant="contained" type="submit">
              SUBMIT
            </Button>
            <Button
              variant="contained"
              color="error"
              style={{ marginLeft: "10px" }}
              onClick={() => navigate("/admin/invoice")}
            >
              KEMBALI
            </Button>
          </div>
        </Card>
      </form>
    </Grid>
  );
}
